"use strict";import{css as s}from"@spectrum-web-components/base";const t=s`
:host{display:table-header-group}:host .spectrum-Table-scroller{position:sticky;top:0;z-index:2}:host{display:flex}
`;export default t;
//# sourceMappingURL=table-head.css.js.map
